export default __webpack_public_path__ + "static/buttonfactions-5feb2c0d9b4b77fca9725bd39843213c.png";